import { createVanIconComponent } from "./van"

const ClosedEye = createVanIconComponent("closed-eye")
export default ClosedEye
